import { isWeb } from "@memorang/helpers/platform";
import * as Clipboard from "expo-clipboard";
import { useRef } from "react";
import { type Selection, createClipboardActions } from "./helpers";

export const useClipboardActions = ({
	value,
	onChangeText,
	onSelectionChange,
	selection,
	maxLength,
}: {
	value?: string;
	onChangeText: (value: string) => void;
	onSelectionChange?: (selection: Selection) => void;
	selection?: Selection;
	maxLength?: number;
}) => {
	const hasSelection = selection != null && selection.start !== selection.end;
	const current = value ?? "";
	const valueRef = useRef(value);
	const selectionRef = useRef(selection);
	valueRef.current = value;
	selectionRef.current = selection;
	const { handleCopy, handleCut, handlePaste } = createClipboardActions({
		clipboard: Clipboard,
		getValue: () => valueRef.current,
		getSelection: () => selectionRef.current,
		getDocumentSelection:
			isWeb && typeof window !== "undefined"
				? () => window.getSelection()?.toString()
				: undefined,
		onChangeText,
		onSelectionChange,
		maxLength,
	});

	const canCopy = isWeb || current.length > 0;
	const canCut = hasSelection;

	return {
		handleCopy,
		handleCut,
		handlePaste,
		canCopy,
		canCut,
	};
};
